import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/audit';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream-100 px-4 py-14 sm:px-6 sm:py-20" data-id="element-144" data-mp="1cgb8le7dgifo">
      <div className="mx-auto w-full max-w-3xl" data-id="element-145" data-mp="2a179eoa8d30x">
        <SectionHeading eyebrow="❓ Before you decide" title="Frequently asked questions" data-id="element-146" data-mp="29zw6eqolzzav" />

        <div className="mt-10 space-y-2.5" data-id="element-147" data-mp="203ss6mghga7k">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/8" data-id="element-148" data-mp="1v46hajo4n61x" data-mpi={i}>
                <h3 data-id="element-149" data-mp="jpsxpr0epcrp">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream-50" data-id="element-150" data-mp="jpazwpy3iqho">
                    <span className="text-[15px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-151" data-mp="1apar7dy146se">
                      {f.q}
                    </span>
                    <ChevronDownIcon className={['h-5 w-5 shrink-0 text-gold-500 transition-transform duration-200 ease-out', isOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-152" data-mp="11wz1juaqondh" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-153" data-mp="iyczod7ees8i">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-154" data-mp="j0hcjkn9z1kx">
                      <p className="px-5 pb-5 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-155" data-mp="2ku3owsyeyos6">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-156" data-mp="33men49i4hyjy">
          <CTAButton label="Get the Complex Rehab Case Audit™ now" subLabel="$27 one-time · 7-day guarantee" data-id="element-157" data-mp="33m4u0d1s7ba1" />
        </div>
      </div>
    </section>;
}